module.exports = __webpack_public_path__ + "img/aaf.473885bd.png";